import fr from 'vee-validate/dist/locale/fr'
import en from 'vee-validate/dist/locale/en'
import de from 'vee-validate/dist/locale/de'
import es from 'vee-validate/dist/locale/es'

export const dictionary = { fr, en, de, es }
